const selectTours = (state) => state.tours.tours;

export default selectTours;
